<template>
  <div>
    <div
      v-if="!hideIntro"
      class="flex items-center space-x-5 rounded bg-primary-50 p-6 text-sm text-primary-500"
    >
      <Icon
        icon="robot"
        prefix="fal"
        class="text-3xl"
      />
      <p>{{ $t('share_ai_assistant_intro') }}</p>
    </div>

    <AiDraft
      :key="language"
      v-model="post"
      :endpoint="`${aiEndpoint}/${language}/${platform}`"
      :body="aiBody"
      :language="language"
      :partner-name="partnerName"
      :initial-text="initialText"
      class="mb-6 shadow"
      :class="{ 'mt-6': !hideIntro }"
      :replacements="{ '[link]': landingPageUrl }"
      @status="(value) => (status = value)"
    >
      <template #media>
        <slot name="media" />
      </template>
    </AiDraft>

    <div class="flex flex-wrap items-center gap-3 lg:gap-4">
      <ShareCopyButton
        :source="post"
        :label="copyLabel"
        :disabled="['pending', 'error'].includes(status)"
      />
      <ShareOpenLink
        v-if="openHref && openLabel"
        :href="openHref"
        :label="openLabel"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AiGenerationStatus } from '~/types/ai'

defineProps<{
  platform: string
  aiEndpoint: string
  aiBody?: Record<string, unknown>
  language: string
  landingPageUrl: string
  copyLabel: string
  partnerName?: string
  initialText?: string | null
  openHref?: string
  openLabel?: string
  hideIntro?: boolean
}>()

const post = ref('')
const status = ref<AiGenerationStatus>('idle')
</script>
